import PropTypes from "prop-types"
import React, { useEffect, useState, useRef, useCallback } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom";
import Utils from '../../pages/Utility';
import { get } from "../../helpers/api_helper";

//i18n
import { withTranslation } from "react-i18next";

// redux
import { connect } from "react-redux";
import { getNotiSuccess } from "../../store/actions";

const SidebarContent = props => {
  // console.log('props on slidebar content', props);

  const [isModerator, setIsModerator] = useState(false);
  const [isDealer, setIsDealer] = useState(false);
  const [isAutoLead, setIsLeadAuto] = useState(false);

  const ref = useRef()
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active")
    item.style.color = props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor;
    item.style.fontWeight = 'bold';
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }
    if (parent) {
      parent.classList.add("mm-active")
      parent.style.color = "green";
      const parent2 = parent.parentElement
      if (parent2) {
        parent2.classList.add("mm-show") // ul tag
        const parent3 = parent2.parentElement // li tag
        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.style.color = props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor;
          parent3.childNodes[0].classList.add("mm-active") //a
          parent3.childNodes[0].style.color = props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor;
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
              parent5.childNodes[0].style.color = props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }, [props.user]);
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname
    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname, activateParentDropdown, props.user])
  useEffect(() => {
    ref.current.recalculate();
    console.log('user on slidebar', props?.user);
    if (props?.user?.moderator?.length > 0) {
      setIsModerator(true);
    } else
      setIsModerator(false);
    if (props?.user?.dealer?.length > 0) {
      setIsDealer(true);
    } else
      setIsDealer(false);
    props?.user?.project?.map((item) => {
      if (item.assignType == 'auto')
        setIsLeadAuto(true);
    })

  }, [props.user]);
  const scrollElement = (item) => {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }
  return (
    <React.Fragment>
      <SimpleBar ref={ref} className="vertical-simplebar">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="mdi mdi-airplay" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
              {/* <ul className="sub-menu">
                <li><Link to="/dashboard">{props.t("Dashboard")} 1</Link></li>
                <li><Link to="/dashboard2">{props.t("Dashboard")} 2</Link></li>
              </ul> */}
            </li>
            {props.user?.role == 'Admin' &&
              <>
                <li>
                  <Link to="/company" className="waves-effect">
                    <i className="mdi mdi-office-building" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                    <span>{props.t("Company Profile")}</span>
                  </Link>
                </li>
                {props?.user?.companyId &&
                  <>
                    <li>
                      <Link to="/project" className="waves-effect">
                        <i className="mdi mdi-briefcase" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                        <span>{props.t("Projects")}</span>
                      </Link>
                    </li>
                    {isModerator &&
                      <li>
                        <Link to="/moderator" className="waves-effect">
                          <i className="mdi mdi-account-settings" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                          <span>{props.t("Moderators")}</span>
                        </Link>
                      </li>
                    }
                    {isDealer &&
                      <li>
                        <Link to="/dealer" className="waves-effect">
                          <i className="mdi mdi-account-multiple" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                          <span>{props.t("Channel Partners")}</span>
                        </Link>
                      </li>
                    }
                  </>
                }
              </>
            }
            {props.user?.role == 'Moderator' &&
              <li>
                <Link to="/dealer" className="waves-effect">
                  <i className="mdi mdi-account-circle-outline" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                  <span>{props.t("Channel Partners")}</span>
                </Link>
                {/* <ul className="sub-menu">
                <li><Link to="/tasks-list">{props.t("Task List")}</Link></li>
                <li><Link to="/tasks-kanban">{props.t("Kanban Board")}</Link></li>
                <li><Link to="/tasks-create">{props.t("Create Task")}</Link></li>
              </ul> */}
              </li>
            }
            <li>
                      <Link to="#" className="waves-effect">
                        <i className="mdi mdi-sale" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                        {props?.notis.length > 0 && props?.notis[0].count > 0 &&
                          <span className="badge rounded-pill float-end"
                            style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, paddingTop: 3 }}>{props?.notis[0]?.count}</span>
                        }
                        <span>Lead Distribution</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="waves-effect">
                        <i className="mdi mdi-checkbox-multiple-marked" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                        {props?.notis.length > 0 && props?.notis[0].count > 0 &&
                          <span className="badge rounded-pill float-end"
                            style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, paddingTop: 3 }}>{props?.notis[0]?.count}</span>
                        }
                        <span>Add Lead</span>
                      </Link>
                    </li>
            {props?.user?.companyId &&
              <>
                {props?.user?.project?.length > 0 &&
                  <>
                    <li>
                      <Link to="/lead/list" className="waves-effect">
                        <i className="mdi mdi-account-check" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                        {/* <span className="badge rounded-pill float-end"
                          style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, paddingTop: 3 }}>3</span> */}
                        <span>{props.t(props?.user?.role=='Admin' ? "Moderator Leads" : "Leads")}</span>
                      </Link>
                    </li>
                    {isAutoLead && props?.user?.role=='Admin' &&
                      <li>
                        <Link to="/auto/lead/list" className="waves-effect">
                          <i className="mdi mdi-auto-fix" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                          {/* <span className="badge rounded-pill float-end"
                  style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, paddingTop: 3 }}>3</span> */}
                          <span>{props.t("Auto Leads")}</span>
                        </Link>
                      </li>
                    }
                    <li>
                      <Link to="/notification" className="waves-effect">
                        <i className="mdi mdi-bell" style={{ color: props?.user?.company?.theme ? props?.user?.company?.theme : Utils.themeColor }}></i>
                        {props?.notis.length > 0 && props?.notis[0].count > 0 &&
                          <span className="badge rounded-pill float-end"
                            style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, paddingTop: 3 }}>{props?.notis[0]?.count}</span>
                        }
                        <span>{props.t("Notifications")}</span>
                      </Link>
                    </li>
                    
                  </>
                }
              </>
            }
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment >
  )
}

const mapStateToProps = state => {
  const { notis } = state.notification;
  return { notis }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  getNotiSuccess: PropTypes.func,
}

export default withRouter(withTranslation()(connect(mapStateToProps, { getNotiSuccess })(SidebarContent)))